import React, { FC, useCallback } from 'react'
import InfoBlock from './InfoBlock'

type Props = {
  name: string
  title: string
  subtitle: string
  infoContent?: string
  value: 'Yes' | 'No' | undefined
  modifierClass: string
  onChange?: (value: string) => void
}

export const BinaryButton: FC<Props> = ({
  name,
  title,
  subtitle,
  infoContent,
  value = 'No',
  modifierClass,
  onChange = () => {},
}) => {
  const handleClick = useCallback(
    (value: string) => {
      onChange(value)
    },
    [onChange]
  )
  return (
    <div
      className={`binary-button__container ${modifierClass || ''}`}
      data-testid={`binary-button-${name}`}
    >
      {title ? <div className="binary-button__title">{title}</div> : null}
      {subtitle ? (
        <div className="binary-button__subtitle">{subtitle}</div>
      ) : null}
      {infoContent ? <InfoBlock>{infoContent}</InfoBlock> : null}
      <div className="binary-button__wrapper">
        <div
          className={`binary-button --first ${
            value === 'Yes' ? '--active' : ''
          }`}
          data-testid="binary-button-0"
          onClick={() => {
            handleClick('Yes')
          }}
          onKeyUp={(event) => {
            if (['Enter', ' '].includes(event.key)) {
              handleClick('Yes')
            }
          }}
          tabIndex={0}
        >
          Yes
        </div>
        <div
          className={`binary-button --last ${value === 'No' ? '--active' : ''}`}
          data-testid="binary-button-1"
          onClick={() => {
            handleClick('No')
          }}
          onKeyUp={(event) => {
            if (['Enter', ' '].includes(event.key)) {
              handleClick('No')
            }
          }}
          tabIndex={0}
        >
          No
        </div>
      </div>
    </div>
  )
}

export default BinaryButton
